import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { useRole } from "../hooks/useRole";
import { sidebarItems } from "../pages/admin/Navbars/SidebarData";

GuestGuard.propTypes = {
  children: PropTypes.node,
};

export default function GuestGuard({ children }) {
  const { token } = useAuth();
  const { role, user } = useRole();
  console.log(user);

  // Check if user has any admin access
  const hasAdminAccess = () => {
    // Any role indicates admin access
    if (role) {
      return true;
    }

    // Any permissions indicate admin access
    if (user && user.permissions && user.permissions.length > 0) {
      return true;
    }

    return false;
  };

  // Redirect admin users to admin dashboard
  if (token && hasAdminAccess()) {
    const permissions = user.permissions || [];

    const path = sidebarItems.find((item) => item.module === permissions[0]);

    return <Navigate to={path?.url ?? "/"} />;
  }

  // Allow access to guest pages
  return <>{children}</>;
}
